// extracted by mini-css-extract-plugin
export default {"root":"EditUserActionModal_root__V+swv","container":"EditUserActionModal_container__6rZRS"};